import {
  GENERATE_LINK_REQUEST, GENERATING_LINK_SUCCEDDED, GENERATING_LINK_FAILED,
  GENERATE_ANONYMOUS_LINKS_REQUEST, GENERATING_ANONYMOUS_LINKS_SUCCEDDED, GENERATING_ANONYMOUS_LINKS_FAILED,
  FETCH_ALL_NDA_TEMPLATE_REQUEST, FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED, FETCHING_ALL_NDA_TEMPLATE_FAILED,
  GENERATING_LINK_FOR_ENTITY, GENERATING_LINK_FOR_ENTITY_FAILED, GENERATING_LINK_FOR_ENTITY_SUCCEEDED, INVALIDATE_GENERATE_LINK
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import _ from 'lodash';

const apiUrl = process.env.REACT_APP_API_URL;
const COLLECTION_URL = `${apiUrl}/api/2.0/collections`;
const ASSETS_URL = `${apiUrl}/api/2.0/assets`;
const NDA_TEMPLATE_URL = `${apiUrl}/api/2.0/nda-templates`;

/** 
* Generate anonymous link request
*/
export const generateAnonymousLinksRequest = createAction(GENERATE_ANONYMOUS_LINKS_REQUEST, (entities, request, callback) => ({ entities, request, callback }));
const generateAnonymousLinksSuccedded = createAction(GENERATING_ANONYMOUS_LINKS_SUCCEDDED);
const generateAnonymousLinksFailed = createAction(GENERATING_ANONYMOUS_LINKS_FAILED);

function* generateAnonymousLinksSaga(action) {
  const { entities, request, callback} = action.payload;

  const createGenerateLinkAPI = (entity) => {
    var url = COLLECTION_URL;
    if (entity.entityType === 'asset') {
      url = ASSETS_URL;
    }

    url = buildUrl(url, {
      path: `${entity.id}/link`
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => {
      return {
        ...response.data,
        entity: entity
      }
    });
  }

  try {
    const sagas = entities.map(entity => {
      return call(createGenerateLinkAPI, entity);
    })

    const response = yield all(sagas);
    console.log(response);
    yield put(generateAnonymousLinksSuccedded(response));
    const application = yield select((state) => state.application);
    yield call(callback, application);
  } catch (error) {
    yield put(generateAnonymousLinksFailed({ error }));
  }
}

/** 
* Generate link for assets and collections
*/
export const invalidateGenerateLink = createAction(INVALIDATE_GENERATE_LINK);
export const generateLinkForEntity = createAction(GENERATING_LINK_FOR_ENTITY, (entity, request) => ({ entity, request }));
const generateLinkForEntitySucceeded = createAction(GENERATING_LINK_FOR_ENTITY_SUCCEEDED);
const generateLinkForEntityFailed = createAction(GENERATING_LINK_FOR_ENTITY_FAILED);

function* generateEntityLinkSaga(action) {

  const {entity, request} = action.payload
 
  const createGenerateLinkAPI = () => {

    var url = COLLECTION_URL;
    if (entity.entityType === 'asset') {
      url = ASSETS_URL;
    }

    url = buildUrl(url, {
      path: `${entity.id}/link`
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => {
      return {
        ...response.data,
        entity: entity
      }
    });
  }

  try {
    const response = yield call(createGenerateLinkAPI);
    yield put(generateLinkForEntitySucceeded(response));
  } catch (error) {
    yield put(generateLinkForEntityFailed({ entity, request, error }));
  }
}


/** 
* Generate link request
*/
export const generateLinkRequest = createAction(GENERATE_LINK_REQUEST, (request, callback) => {
  return { request, callback }
});

const generateLinkSuccedded = createAction(GENERATING_LINK_SUCCEDDED);
const generateLinkFailed = createAction(GENERATING_LINK_FAILED);

function* generateLinkRequestSaga(action) {
  const { request, callback } = action.payload;

  const link = request.link;
  var dataRequest = {
    ...request,
    type: 'integration'
  };

  if (request.collection) {
    dataRequest['collection'] = _.get(request, 'collection.id');
  } else if (request.assets) {
    dataRequest['assets'] = (request.assets || []).map(asset => asset.id);
  }

  const createGenerateLinkAPI = () => {
    let url = buildUrl(apiUrl, {
      path: `/api/2.0/links/integrations`
    });

    return axios({
      method: 'POST',
      url: url,
      data: dataRequest
    }).then(response => {
      return response.data;
    });
  }

  const updateGenerateLinkAPI = (id) => {
    let url = buildUrl(apiUrl, {
      path: `/api/2.0/links/integrations/${id}`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: dataRequest
    }).then(response => {
      return response.data;
    });
  }

  try {
    const response = link ? yield call(updateGenerateLinkAPI, link) : yield call(createGenerateLinkAPI);
    yield put(generateLinkSuccedded({ response }));
    const application = yield select((state) => state.application);
    yield call(callback, application);
  } catch (error) {
    yield put(generateLinkFailed({ error }));
  }
}

/* Fetch Nda Templates Request */

export const fetchAllNDATemplates = createAction(FETCH_ALL_NDA_TEMPLATE_REQUEST);
const fetchingAllNDATemplatesSuccedded = createAction(FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED);
const fetchingAllNDATemplatesFailed = createAction(FETCHING_ALL_NDA_TEMPLATE_FAILED);

function* fetchNDARequestSaga(action) {

  const fetchNDATemplatesAPI = (id) => {
  
    return axios({
      method: 'GET',
      url: NDA_TEMPLATE_URL
    }).then(response => {
      return response.data;
    });
  }

  try {
    const response = yield call(fetchNDATemplatesAPI);
    yield put(fetchingAllNDATemplatesSuccedded(response));
  } catch (error) {
    yield put(fetchingAllNDATemplatesFailed(error));
  }
}

export default function* linksSaga() {
  yield takeEvery(GENERATE_LINK_REQUEST, generateLinkRequestSaga);
  yield takeEvery(GENERATE_ANONYMOUS_LINKS_REQUEST, generateAnonymousLinksSaga);
  yield takeEvery(FETCH_ALL_NDA_TEMPLATE_REQUEST, fetchNDARequestSaga)
  yield takeEvery(GENERATING_LINK_FOR_ENTITY, generateEntityLinkSaga)
};
